package redmcrosco.alex.farmatch.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.PlayArrow
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import farmatch.composeapp.generated.resources.*
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TutorialScreen(onBack: () -> Unit) {
    var selectedTab by remember { mutableStateOf(0) }

    Scaffold(
        containerColor = Color.Transparent,
        topBar = {
            TopAppBar(
                colors = TopAppBarDefaults.topAppBarColors(containerColor = Color.Transparent),
                title = { Text("Tutorial e Istruzioni") },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(AppIcons.ArrowBack, contentDescription = "Back")
                    }
                }
            )
        }
    ) { padding ->
        Column(modifier = Modifier.fillMaxSize().padding(padding)) {
            TabRow(selectedTabIndex = selectedTab) {
                Tab(selected = selectedTab == 0, onClick = { selectedTab = 0 }, text = { Text("Farmacista", fontSize = 12.sp) })
                Tab(selected = selectedTab == 1, onClick = { selectedTab = 1 }, text = { Text("Farmacia", fontSize = 12.sp) })
            }

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(16.dp)
                    .verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                if (selectedTab == 0) {
                    PharmacistTutorial()
                } else {
                    PharmacyTutorial()
                }
                
                Spacer(Modifier.height(16.dp))
                
                Button(
                    onClick = { /* Apri YouTube Link futuro */ },
                    modifier = Modifier.fillMaxWidth(),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFFF0000)), // Rosso YouTube
                    shape = RoundedCornerShape(12.dp)
                ) {
                    Icon(Icons.Default.PlayArrow, contentDescription = null)
                    Spacer(Modifier.width(8.dp))
                    Text("GUARDA VIDEO TUTORIAL (YouTube)", fontWeight = FontWeight.Bold)
                }

                Spacer(Modifier.height(24.dp))
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(containerColor = Color(0xFFFFEBEE))
                ) {
                    Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(AppIcons.Support, contentDescription = null, tint = Color.Red)
                        Spacer(Modifier.width(16.dp))
                        Column {
                            Text("Dubbi o Suggerimenti?", fontWeight = FontWeight.Bold, color = Color.Red)
                            Text("Inviaci un feedback dalla sezione Profilo > Supporto.", style = MaterialTheme.typography.bodySmall)
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun PharmacistTutorial() {
    TutorialStep(
        number = "1",
        title = "Cerca i tuoi Turni",
        description = "Usa la tab 'Cerca' per filtrare le farmacie per provincia o città. Puoi selezionare un periodo specifico sul calendario.",
        icon = AppIcons.Search
    )
    TutorialStep(
        number = "2",
        title = "La tua Disponibilità",
        description = "Nella tab 'Annunci', pubblica i giorni in cui sei libero. Puoi aggiungere giorni singoli o interi periodi (es. Lun-Ven).",
        icon = AppIcons.Turno
    )
    TutorialStep(
        number = "3",
        title = "Accetta l'Emergenza",
        description = "I turni in rosso nella Home sono urgenti. Clicca su ACCETTA e contatta subito la farmacia se necessario.",
        icon = AppIcons.Event,
        isEmergency = true
    )
    TutorialStep(
        number = "4",
        title = "Guadagna Reputazione",
        description = "Completa i turni per aumentare le tue stelle. Ricorda: disdire un turno confermato influisce negativamente!",
        icon = AppIcons.Star
    )
}

@Composable
fun PharmacyTutorial() {
    TutorialStep(
        number = "1",
        title = "Pubblica una Richiesta",
        description = "Nella tab 'Annunci', specifica quanti farmacisti ti servono. Puoi pubblicare turni multipli per la stessa data.",
        icon = AppIcons.Add
    )
    TutorialStep(
        number = "2",
        title = "Gestisci i Matching",
        description = "Quando un farmacista accetta, ricevi una notifica. Vai nella Home per dare la CONFERMA finale e chiudere il turno.",
        icon = AppIcons.Check
    )
    TutorialStep(
        number = "3",
        title = "Libera in Emergenza",
        description = "Se un farmacista ha un imprevisto, puoi cliccare su 'LIBERA TURNO' per rimetterlo subito a disposizione di altri.",
        icon = AppIcons.Delete,
        isEmergency = true
    )
    TutorialStep(
        number = "4",
        title = "Ricerca Diretta",
        description = "Cerca un farmacista per nome o zona e inviagli una 'Proposta Diretta' se hai un'esigenza specifica.",
        icon = AppIcons.Account
    )
}

@Composable
fun TutorialStep(number: String, title: String, description: String, icon: androidx.compose.ui.graphics.vector.ImageVector, isEmergency: Boolean = false) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp),
        colors = CardDefaults.cardColors(containerColor = if (isEmergency) Color(0xFFFFEBEE).copy(alpha = 0.5f) else Color.White)
    ) {
        Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(
                modifier = Modifier
                    .size(40.dp)
                    .background(if (isEmergency) Color.Red else MaterialTheme.colorScheme.primary, RoundedCornerShape(20.dp)),
                contentAlignment = Alignment.Center
            ) {
                Text(number, color = Color.White, fontWeight = FontWeight.Bold)
            }
            Spacer(Modifier.width(16.dp))
            Column(modifier = Modifier.weight(1f)) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(icon, contentDescription = null, tint = if (isEmergency) Color.Red else MaterialTheme.colorScheme.primary, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(8.dp))
                    Text(title, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
                }
                Text(description, style = MaterialTheme.typography.bodySmall, color = Color.DarkGray)
            }
        }
    }
}
